/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Solo-purchase guard: the Advent Calendar (handle "advent-calendar") can only be
 * bought on its own. This blocks the native /cart/add form submission whenever
 * that rule would be violated, in either direction.
 *
 * Known limitation, by design: this only covers standard <form action="/cart/add">
 * submissions. Dynamic checkout buttons (Apple Pay / Google Pay / Shop Pay) and any
 * app-injected "quick add" widgets that call /cart/add.js directly via fetch, rather
 * than submitting this form, are NOT covered. The dynamic payment button is disabled
 * on the Advent Calendar template for this reason, and app upsell blocks (Rebuy,
 * recommendations) are left out of that template entirely. Keep both of those choices
 * in place if this template is ever duplicated or reused for another solo-purchase item.
 */
(function () {
  var SOLO_PURCHASE_HANDLES = ['advent-calendar'];

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !form.querySelector('[name="id"]')) return;

    event.preventDefault();

    var toInput = form.querySelector('[name="properties[To]"]');
    var fromInput = form.querySelector('[name="properties[From]"]');
    var isPersonalized = !!((toInput && toInput.value.trim()) || (fromInput && fromInput.value.trim()));
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (isPersonalized && quantity !== 1) {
      showFormError(form, 'Personalized calendars can only be added one at a time. Reduce the quantity to 1, or remove your personalization to order more than one.');
      return;
    }

    var productSection = form.closest('[data-product-handle]');
    var submittingHandle = productSection ? productSection.getAttribute('data-product-handle') : null;
    var isSubmittingSolo = submittingHandle && SOLO_PURCHASE_HANDLES.indexOf(submittingHandle) !== -1;

    fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartHasSolo = cart.items.some(function (item) {
          return SOLO_PURCHASE_HANDLES.indexOf(item.handle) !== -1;
        });
        var cartHasNonSolo = cart.items.some(function (item) {
          return SOLO_PURCHASE_HANDLES.indexOf(item.handle) === -1;
        });

        if (isSubmittingSolo && cartHasNonSolo) {
          showFormError(form, 'The advent calendar can only be purchased on its own. Clear your cart first, or place your other order separately.');
          return;
        }

        if (!isSubmittingSolo && cartHasSolo) {
          showFormError(form, 'Your cart contains the advent calendar, which can only be purchased on its own. Remove it to add other items.');
          return;
        }

        form.submit();
      })
      .catch(function () {
        form.submit(); // fail open: a broken cart check shouldn't block a legitimate purchase
      });
  }, true);

  function showFormError(form, message) {
    var existing = form.querySelector('.FormError');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'FormError Alert Alert--error';
    el.textContent = message;
    var button = form.querySelector('.ProductForm__AddToCart');
    (button || form).insertAdjacentElement('afterend', el);
    setTimeout(function () { el.remove(); }, 4000);
  }
})();

/**
 * Gift message character counter. The actual limit is enforced natively via the
 * input's maxlength attribute; this just keeps the visible "x / max" count in sync.
 */
(function () {
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-gift-message-input]')) return;
    var field = event.target.closest('.ProductForm__GiftMessageField');
    var counter = field ? field.querySelector('[data-gift-message-count]') : null;
    if (!counter) return;
    counter.textContent = event.target.value.length + ' / ' + counter.getAttribute('data-max');
  });
})();

/**
 * Once a gift message is entered, lock quantity to 1. A personalized calendar is a
 * unique physical item (one hand-written tag), so a single line item can't represent
 * more than one without staff duplicating the same tag by hand. The submit-time check
 * above is the actual enforcement; this just keeps the UI honest about it beforehand.
 */
(function () {
  function isGiftPersonalized(form) {
    var toInput = form.querySelector('[name="properties[To]"]');
    var fromInput = form.querySelector('[name="properties[From]"]');
    return !!((toInput && toInput.value.trim()) || (fromInput && fromInput.value.trim()));
  }

  function syncQuantityLock(form) {
    var qtyInput = form.querySelector('.QuantitySelector__CurrentQuantity');
    if (!qtyInput) return;
    var qtyButtons = form.querySelectorAll('[data-action="decrease-quantity"], [data-action="increase-quantity"]');
    var notice = form.querySelector('[data-gift-quantity-notice]');

    if (isGiftPersonalized(form)) {
      qtyInput.value = 1;
      qtyInput.setAttribute('readonly', 'readonly');
      qtyButtons.forEach(function (btn) { btn.setAttribute('disabled', 'disabled'); });
      if (notice) notice.style.display = 'block';
    } else {
      qtyInput.removeAttribute('readonly');
      qtyButtons.forEach(function (btn) { btn.removeAttribute('disabled'); });
      if (notice) notice.style.display = 'none';
    }
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-gift-message-input]')) return;
    var form = event.target.closest('form[action*="/cart/add"]');
    if (form) syncQuantityLock(form);
  });
})();

/**
 * Neutralizes a pre-existing, unrelated bug: the theme's stock cart-quantity
 * handling (theme.js, CartSection._reloadPageWithQuantity) is still wired up
 * via native "change" events on .QuantitySelector__CurrentQuantity, and tries
 * to read a data-line attribute this store's custom quantity markup doesn't
 * have (data-change-key is used instead). That sends every typed-quantity
 * edit, on any cart line, to a broken /cart/change?...&line=null request and
 * Shopify's generic error page, "expected String to be a Integer: line".
 *
 * The custom data-change-key blur handler in cart-items.liquid is what
 * actually updates the cart correctly. Browsers fire "change" before "blur"
 * on a text input, so the broken legacy handler was hijacking the page before
 * that blur logic, or the guard below, ever got a chance to run. This simply
 * stops the native change event from reaching it.
 */
(function () {
  if (!window.theme || window.theme.pageType !== 'cart') return;

  window.addEventListener('change', function (event) {
    if (!event.target.matches('.QuantitySelector__CurrentQuantity')) return;
    event.stopImmediatePropagation();
  }, true);
})();

/**
 * Cart-page quantity guard for personalized advent calendars.
 *
 * This store's cart page doesn't use the theme's stock quantity handling at all.
 * cart-items.liquid wires its own click (+/-) and blur (typed value) listeners
 * directly on document, keyed by data-change-key (the cart line's unique `key`,
 * not a positional index), firing /cart/change.js directly. Any guard has to
 * intercept those same two events, matched the same way.
 *
 * Both of that file's listeners are inline and undeferred, so they register
 * before this deferred script even loads. Attaching our listeners to `document`
 * in capture phase wouldn't be early enough on its own, since same-target,
 * same-phase listeners fire in registration order, and theirs would already be
 * first. Attaching to `window` instead guarantees we run first regardless of
 * load order, since window sits earlier than document in the capture path,
 * a structural guarantee, not a timing coincidence.
 */
(function () {
  if (!window.theme || window.theme.pageType !== 'cart') return;

  var personalizedKeys = null;

  fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var keys = new Set();
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        var hasGiftMessage = (props.To && props.To.trim()) || (props.From && props.From.trim());
        if (item.handle === 'advent-calendar' && hasGiftMessage) {
          keys.add(item.key);
        }
      });
      personalizedKeys = keys;
    })
    .catch(function () {
      personalizedKeys = new Set(); // fail open: an unreachable cart shouldn't block a legitimate change
    });

  function blockIncrease(target) {
    var actionsWrapper = target.closest('.CartItem__QuantitySelector') || target.parentElement;
    var existing = actionsWrapper.querySelector('.CartItem__QuantityNotice');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'CartItem__QuantityNotice';
    el.textContent = 'This calendar is personalized, so it stays at one per line. Add another to your cart separately for a different name.';
    actionsWrapper.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  // The +/- buttons
  window.addEventListener('click', function (event) {
    if (!personalizedKeys) return;
    var btn = event.target.closest('[data-change-key][data-delta]');
    if (!btn) return;
    var key = btn.getAttribute('data-change-key');
    var delta = Number(btn.getAttribute('data-delta'));
    if (!personalizedKeys.has(key) || delta <= 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    blockIncrease(btn);
  }, true);

  // Typing a value directly and leaving the field
  window.addEventListener('blur', function (event) {
    if (!personalizedKeys) return;
    var input = event.target.closest && event.target.closest('input[data-change-key]');
    if (!input) return;
    var key = input.getAttribute('data-change-key');
    if (!personalizedKeys.has(key)) return;

    var typed = parseInt((input.value || '0').replace(/[^\d]/g, ''), 10);
    if (!Number.isFinite(typed) || typed <= 1) return;

    event.stopImmediatePropagation();
    input.value = '1';
    blockIncrease(input);
  }, true);
})();